import * as requestFromServer from './branchesCrud';
import {branchesSlice, callTypes} from "./branchesSlice";

const {actions} = branchesSlice;

export const fetchAllBranches = () => dispatch => {
    dispatch(actions.startCall({callType: callTypes.list}));
    return requestFromServer
        .getAllBranches()
        .then(response => {
            const {totalCount, entities} = response.data;
            dispatch(actions.branchesFetched({totalCount, entities}));
        })
        .catch(error => {
            error.clientMessage = 'شعبه های درخواستی یافت نشد.';
            dispatch(actions.catchError({error, callType: callTypes.list}));
        })
}

export const fetchBranches = queryParams => dispatch => {
    dispatch(actions.startCall({callType: callTypes.list}));
    return requestFromServer
        .FindBranches(queryParams)
        .then(response => {
            const {totalCount, entities} = response.data;
            dispatch(actions.branchesFetched({totalCount, entities}));
        })
        .catch(error => {
            error.clientMessage = 'شعبه های درخواستی یافت نشد.';
            dispatch(actions.catchError({error, callType: callTypes.list}));
        })
}

export const fetchBranch = id => dispatch => {
    dispatch(actions.startCall({callType: callTypes.action}));
    return requestFromServer
        .GetBranchById(id)
        .then(response => {
            const branch = response.data;
            dispatch(actions.branchFetched({branchForEdit: branch}));
        })
        .catch(error => {
            error.clientMessage = 'شعبه درخواستی یافت نشد'
            dispatch(actions.catchError({error, callType: callTypes.action}));
        })
}


export const updateBranch = branch => dispatch => {
    dispatch(actions.startCall({callType: callTypes.action}));
    return requestFromServer
        .updateBranch(branch)
        .then(response => {
            const branch = response.data;
            dispatch(actions.branchUpdated({branch}))
        })
        .catch(error => {
            error.clientMessage = "خطایی هنگام بروزرسانی رکورد مربوطه رخ داد."
            dispatch(actions.catchError({error, callType: callTypes.action}));
        })
}


export const deleteBranch = id => dispatch => {
    dispatch(actions.startCall({callType: callTypes.action}));
    return requestFromServer
        .deleteBranch(id)
        .then(() => {
            dispatch(actions.branchDeleted({id}));
        })
        .catch(error => {
            error.clientMessage = 'عدم امکان پاک کردن شعبه.'
            dispatch(actions.catchError({error, callType: callTypes.action}));
        })
}

export const createBranch = branchForCreation => dispatch => {
    dispatch(actions.startCall({callType: callTypes.action}));
    return requestFromServer
        .createBranch(branchForCreation)
        .then(response => {
            const branch = response.data;
            dispatch(actions.branchCreated({branch}));
        })
        .catch(error => {
            error.clientMessage = 'خطایی هنگام ایجاد شعبه رخ داد.';
            dispatch(actions.catchError({error, callType: callTypes.action}));
        })
}


export const toggleBranch = id => dispatch => {
    dispatch(actions.startCall({callType: callTypes.action}));
    return requestFromServer
        .ToggleLock(id)
        .then(() => {
            dispatch(actions.branchToggled({id}))
        })
        .catch(error => {
            error.clientMessage = 'خطایی هنگام تغییر وضعیت رخ داد.';
            dispatch(actions.catchError({error, callType: callTypes.action}));
        })
}